<div class="flex flex-col flex-auto min-w-0">
    <!-- Header -->
    <!-- Main -->
    <div class="border-t -mt-px py-2">
        <div class="w-full max-w-screen-xl mx-auto">
            <div class="py-2">
                <div class="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full min-w-0 p-5">
                    <div class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden">
                        <div class="row justify-between card-header px-6 py-3">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                                PM Progress
                            </div>
                        </div>

                        <div id="pmCompletenesspieChart" class="h-64"></div>
                    </div>

                    <div class="sm:col-span-2 lg:col-span-2 bg-card shadow rounded-2xl overflow-hidden">
                        <div class="row justify-between card-header px-6 py-3">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                                PM Activity Trend
                            </div>
                        </div>

                        <div class="px-6 py-2">
                            <div id="barGraph" class="h-64"></div>
                        </div>
                    </div>

                    <div class="sm:col-span-4 lg:col-span-4 bg-card shadow rounded-2xl overflow-hidden p-6">
                        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-12">
                            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('field')}"
                                (click)="toggleSummary('field')">
                                Field Summary
                            </a>
                            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': !router.url.includes('field')}"
                                (click)="toggleSummary('string')">
                                String Summary
                            </a>
                        </div>

                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>